import { Context } from '@nuxt/types'
import { WebcastApi } from '~/apiclient/apiwebcasts'
import { qsToBool } from '~/assets/ts/utils/params'

export default async function ({
  $users,
  params,
  store,
  error,
  query,
}: Context) {
  const broadcasterID = params.broadcasterID
  if (broadcasterID) {
    const webcastID = params.webcastID
    if (webcastID) {
      await store.dispatch('webcasts/fetchWebcastReplay', {
        broadcasterID,
        webcastID,
      })
      const replay = (await store.getters['webcasts/webcastReplay'](
        webcastID
      )) as WebcastApi | undefined
      let cantReplay = !replay?.webcastReplay
      if (cantReplay && replay && qsToBool(query.preview)) {
        if (
          $users.user?.broadcasterIds.includes(replay.broadcasterID) ||
          $users.user?.admin
        ) {
          cantReplay = false
        }
      }
      if (cantReplay) {
        error({
          statusCode: 404,
          message: 'Webcast replay not found',
        })
      }
    } else {
      await store.dispatch('webcasts/fetchWebcastsInProgress', {
        broadcasterID,
      })
    }
  } else {
    error({
      statusCode: 404,
      message: 'Broadcaster not found',
    })
  }
}
